import { jsx as l } from "react/jsx-runtime";
const h = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        fillRule: "evenodd",
        d: "M2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm12.407 14.914h1.939V4.04h-1.939zm-3.995-2.506h1.57V15.57h-.918c-.602 0-.82-.234-.82-.802v-4.211H12.1V8.719h-1.855V6.346h-2.29V8.72H6.72v1.838h1.237v4.378c0 1.537.785 2.473 2.456 2.473",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  h as default
};
